import { SnowplowService } from 'wanderu-service-analytics';

const category = 'Banner';

function bannerRendered({ date }) {
    SnowplowService.fireStructuredEvent({
        category,
        action: 'loaded',
        property: JSON.stringify({ date }),
    });
}

export default { bannerRendered };
